/**
 * Bastion brand accent — Cool Porcelain.
 *
 * Single source of truth for the UI chrome accent (CTAs, selected states,
 * checklist eyebrows, nav highlights). Distinct from the rating triad
 * (green / yellow / red in `lib/rating-tiers.ts`) and from chart series yellows.
 *
 * Prefer importing these constants in TS/TSX. In CSS, use the matching
 * custom properties defined on `:root` in `app/globals.css`.
 *
 * Do NOT use porcelain for watchlist stars / favorite marks — those stay gold
 * (`BASTION_GOLD` below). Porcelain reads as muted white there and loses the
 * “saved” signal.
 */

export const BASTION_ACCENT = '#DCE2EC';
export const BASTION_ACCENT_RGB = '220, 226, 236';
/** Text / icon color on a solid accent fill. */
export const BASTION_ACCENT_INK = '#181818';

export const BASTION_ACCENT_SOFT = `rgba(${BASTION_ACCENT_RGB}, 0.14)`;
export const BASTION_ACCENT_SOFT_HOVER = `rgba(${BASTION_ACCENT_RGB}, 0.22)`;
export const BASTION_ACCENT_BORDER = `rgba(${BASTION_ACCENT_RGB}, 0.38)`;
export const BASTION_ACCENT_GLOW = `rgba(${BASTION_ACCENT_RGB}, 0.18)`;

/** Watchlist stars, favorite marks, portfolio-tag icons. Keep gold. */
export const BASTION_GOLD = '#E8C97A';
export const BASTION_GOLD_RGB = '232, 201, 122';
export const BASTION_GOLD_SOFT = `rgba(${BASTION_GOLD_RGB}, 0.14)`;
export const BASTION_GOLD_SOFT_HOVER = `rgba(${BASTION_GOLD_RGB}, 0.22)`;
export const BASTION_GOLD_BORDER = `rgba(${BASTION_GOLD_RGB}, 0.38)`;

/**
 * Premium = the same gold. Use on entry points to Premium features (stock
 * page: Verdict, Portfolio Strategy, portfolio CHECK, All Metrics) as a soft
 * fill / border / tinted label — never a solid fill (one exception: the stock
 * header's CHECK button), never on numbers or data (rating yellows stay data).
 * See DESIGN.md → Premium color.
 */
export const BASTION_PREMIUM = BASTION_GOLD;
export const BASTION_PREMIUM_RGB = BASTION_GOLD_RGB;
